import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BalanceQuery, config, MemberCard, MemberCardQuery, MemberDetails, MemberQuery } from '@fgb/core';
import { DirectivesModule, ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { CommonModule, Location } from '@angular/common';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { SharedModule } from 'src/app/shared/shared.module';
import { Populations } from 'src/app/shared/utilities/populations';
import { PassesModule } from 'src/app/modules/passes/passes.module';

@Component({
  selector: 'fgb-mobile-page-header',
  templateUrl: './mobile-page-header.component.html',
  styleUrls: ['./mobile-page-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    PipesModule,
    DirectivesModule,
    FGBSharedModule,
    LoadingModule,
    SharedModule,
    PassesModule,
  ],
})
export class MobilePageHeaderComponent implements OnInit {
  @Input() showAfter: boolean = true;
  @Input() backButtonLink?: string;
  @Input() pageTitle: string;
  @Input() isHomePage: boolean = false;
  @Input() showBalance: boolean = true;
  @Input() showQr: boolean = true;
  @Input() showAppleWallet: boolean = false;
  populations = Populations;

  screenType = ScreenType;
  memberCard$: Observable<MemberCard | undefined>;
  ecash$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  pointsBalance$: Observable<number | undefined>;
  @HostBinding('attr.is-home-page') get isHomePageAttr() {
    return this.isHomePage;
  }

  constructor(
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private balanceQuery: BalanceQuery,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit() {
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
  }

  goBack() {
    if (this.backButtonLink) {
      this.router.navigate([this.backButtonLink]);
    } else {
      this.location.back();
    }
  }

  gotoWallet() {
    this.router.navigate(['/rewards/wallet']);
  }
}
